import React, { useEffect } from 'react';
import Table from '../../../modules/components/Table'
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddEditCoupons from './AddEditCoupons';
import firebase from "firebase";

export default function Index(props) {

    const [headCells, setHeadCells] = React.useState([]);
    const [headMobileCells, setHeadMobileCells] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState("");
    const [searchCell, setSearchCell] = React.useState([]);
    const [displayInfo, setDisplayInfo] = React.useState([]);
    const [editCells, setEditCells] = React.useState([]);
    const [addCells, setAddCells] = React.useState([]);
    const [addCellsName, setAddCellsName] = React.useState([]);
    const matches = useMediaQuery(theme => theme.breakpoints.up('sm'));

    useEffect(() => {

        setHeadCells([
            { id: 'name', label: 'Name' },
            { id: 'coupon_code', label: 'Code' },
            { id: 'image', label: 'Thumbnail' },
            { id: 'min_orders', label: 'Min. Orders' },
            { id: 'min_point', label: 'Min. Point' },
            { id: 'expired', label: 'Expired Date' },
            { id: 'description', label: 'Description' }
        ])

        setHeadMobileCells([
            { id: 'name', numeric: false, disablePadding: false, label: 'Name' },
        ])
    
        setSearchCell([
            { id: 'id', label: 'ID' },
            { id: 'name', label: 'Name' },
        ])

        setDisplayInfo([
            { id: 'id', label: 'ID' },
            { id: 'name', label: 'Name' },
            { id: 'coupon_code', label: 'Code' },
            { id: 'created', label: 'Created' },
            { id: 'updated', label: 'Updated' },
            { id: 'min_orders', label: 'Min. Orders' },
            { id: 'min_point', label: 'Min. Point' },
            { id: 'description', label: 'Description' }
        ])

        setEditCells([
            { id: 'image', label: 'Image' },
            { id: 'products', label: 'Products' },
            { id: 'expired', label: 'Expired Date' },
            { id: 'type', label: 'Type' },
            { id: 'name', label: 'Name' },
            { id: 'coupon_code', label: 'Code' },
            { id: 'min_orders', label: 'Min. Orders' },
            { id: 'min_point', label: 'Min. Point' },
            { id: 'description', label: 'Description' }
        ])

        setAddCells([
            { id: 'image', label: 'Image' },
            { id: 'products', label: 'Products' },
            { id: 'expired', label: 'Expired Date' },
            { id: 'type', label: 'Type' },
            { id: 'name', label: 'Name' },
            { id: 'coupon_code', label: 'Code' },
            { id: 'min_orders', label: 'Min. Orders' },
            { id: 'min_point', label: 'Min. Point' },
            { id: 'description', label: 'Description' }
        ])

        setAddCellsName({ 
            name: '', 
            coupon_code: '',
            created: firebase.database.ServerValue.TIMESTAMP,
            updated: firebase.database.ServerValue.TIMESTAMP,
            description: '',
            image: []
         })
    
        setSearchValue("name")
        
    }, []);

    return (
    <Grid>
        <Table 
             {...props}
            control={true}
            disabledMove={true}
            customizeDialog={AddEditCoupons}
            orderBy="created" 
            data="coupons" 
            addItemButton={true}
            addItemText="Add coupons"
            addItemIcon={<AddCircleIcon/>}
            addCells={addCells}
            addCellsName={addCellsName}
            folder_data="coupons_zone"
            displayInfo={displayInfo}
            editCells={editCells}
            matches={matches}
            headCells={matches ? headCells : headMobileCells} 
            searchValue={searchValue} 
            searchCell={searchCell}/>
    </Grid>
    )

}
  